<template>
  <div class="vbn">
    <img class="imaBox" :src="imgSrc"/>
    <p class="ts">开发者账号申请已提交成功，请等待审核</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgSrc: require('@/assets/images/ts.png')
    };
  },
  created() {
    sessionStorage.removeItem('ww');
  }
};
</script>

<style scoped="scoped">
  .vbn {
    border-top: 1px solid white;
    width: 1180px;
    margin: 0 auto;
    margin-top: 20px;
    height: 100px;
    background-color: white;
    min-height: calc(100vh - 290px);
  }

  .imaBox {
    display: block;
    width: 100px;
    margin: 94px auto 36px auto;

  }

  .ts {
    font-size: 16px;
    color: #666666;
    text-align: center;

  }
</style>
